import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import transactionReducer from './slices/transactionSlice';
import deliveryReducer from './slices/deliverySlice';
import metalPriceReducer from './slices/metalPriceSlice';
import uiReducer from './slices/uiSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    subscriptions: subscriptionReducer,
    transactions: transactionReducer,
    deliveries: deliveryReducer,
    metalPrices: metalPriceReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
